<template>
    <section class="content">
        <div class="card card-primary">
            <div class="card-body">
            <h3>Maintenance Notification Form</h3>
            <div class="form-group">
                <label for="app_id">Aplikasi</label>
                <select id="app_id" class="form-control" v-model="form.app_id" required>
                    <option value="boscod">boscod</option>
                    <!-- <option value="bosagen">bosagen</option> -->
                </select>
            </div>
            <div class="form-group">
                <label for="data_header">Judul</label>
                <input id="data_header" class="form-control" v-model="form.title" type="text" required />
            </div>
            <div class="form-group">
                <label for="data_contents">Pesan</label>
                <textarea id="data_contents" class="form-control" v-model="form.contents" required></textarea>
            </div>
            <div class="form-group">
                <label for="included_segments">Included Segments (optional)</label>
                <input id="included_segments" class="form-control" v-model="form.included_segments" type="text" />
            </div>
            <button class="btn btn-primary" type="button" @click="submitForm">Submit</button>
        </div>
        </div>
    </section>
</template>

<script>
import Swal from "sweetalert2";
import { authFetch } from "@/libs/hxcore";

export default {
    name: 'Maintenance',
    data() {
        return {
            form: {
                app_id: 'boscod',
                included_segments: '',
                maintenance_mode: true,
                title: 'System Is Under Maintenance',
                contents: 'Sistem sedang dalam pemeliharaan untuk memastikan layanan terbaik bagi Anda. Kami akan segera kembali!',
            }
        };
    },
    methods: {
        submitForm(ev) {
            this.form.maintenance_mode = true;
            var data = Object.keys(this.form)
                .map(
                (key) =>
                    encodeURIComponent(key) + "=" + encodeURIComponent(this.form[key])
                )
                .join("&");

            Swal.fire({
                title: "Apakah anda yakin?",
                text: "maintenance mode akan diaktifkan!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                dangerMode: true,
            }).then((result) => {
                if (result.isConfirmed) {
                    authFetch("/report/notification/maintenance_notif", {
                    method: "POST",
                    body: data,
                    }).then((res) => {
                        return res.json();
                    }).then((js) => {
                        if (js.success) {
                            Swal.fire("Proses Berhasil", ``, "success");
                            this.form = {};
                        } else {
                            Swal.fire("Proses gagal", js.result.errors[0], "error");
                        }
                    });
                }
            });
        }
    }
};
</script>
